/**
 * `fhirSystems.ts` — canonical FHIR `Coding.system` URIs used across the
 * Progress Note edit form, its sections, and the `draftToSoap` adapter.
 *
 * These URIs were previously redeclared as private `const X_SYSTEM = '…'` in
 * several sibling files (`draftToSoap.ts`, `ProgressNoteSections/*`, the inline
 * pickers). Promoting them here keeps a single source of truth so a coding
 * system URI never drifts between the picker that writes a `Coding`, the
 * section that reads it, and the adapter that ships it to the cascade.
 */

/** ICD-10-CM — `Condition.code` / diagnosis codings. */
export const ICD10_SYSTEM = 'http://hl7.org/fhir/sid/icd-10-cm'

/** CPT (AMA) — procedure / E&M / billing codings. */
export const CPT_SYSTEM = 'http://www.ama-assn.org/go/cpt'

/** RxNorm — `MedicationStatement.medicationCodeableConcept` codings. */
export const RXNORM_SYSTEM = 'http://www.nlm.nih.gov/research/umls/rxnorm'

/** LOINC — `Observation.code` / lab-order ServiceRequest codings. */
export const LOINC_SYSTEM = 'http://loinc.org'

/** SNOMED CT — fallback system for codings without a more specific source. */
export const SNOMED_SYSTEM = 'http://snomed.info/sct'
